import CertificatesList from './CertificatesList';

export default CertificatesList;
